// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum Currency {
	Uyu = 1,
	Usd = 2,
	Ars = 3,
}
